import "./CostDropdown.css";
import { Dropdown } from "@ui/Dropdown";
import { MaterialSymbol } from "@ui/MaterialSymbol";
import { createSignal, Show } from "solid-js";
import { AccountCostPanel } from "./AccountCostPanel";
import { ChatCostPanel } from "./ChatCostPanel";

export type CostDropdownVariant = "studio" | "askgvt";

type Props = {
	questionId?: string;
	variant?: CostDropdownVariant;
};

export const CostDropdown = (props: Props) => {
	const variant = () => props.variant ?? "studio";
	const isAskgvt = () => variant() === "askgvt";
	const isChat = () => Boolean(props.questionId);
	const [chatHasUsage, setChatHasUsage] = createSignal(false);

	const triggerLabel = () =>
		isChat() ? "Show chat usage" : "Show account usage";

	return (
		<Dropdown
			class="cost-dropdown cost-dropdown--account"
			placement="bottom end"
			triggerSize="medium"
			aria-label={triggerLabel()}
			triggerTooltip={triggerLabel()}
			triggerStyle={{ width: "2rem", height: "2rem" }}
			// disabled={isChat() && !chatHasUsage()}
			listBoxStyle={{
				width: "min(22.5rem, calc(100vw - 2rem))",
			}}
			trigger={<MaterialSymbol symbol="monitoring" relativeSize="smaller" />}
			// A function, not JSX: Dropdown reads `content` many times, and a JSX
			// prop builds a new panel (and a new usage request) on every read.
			content={() => (
				<Show
					when={props.questionId}
					fallback={<AccountCostPanel showVius={!isAskgvt()} />}
				>
					{(questionId) => (
						<ChatCostPanel
							questionId={questionId()}
							onHasUsageChange={setChatHasUsage}
							chatThinking={isChat() && !chatHasUsage()}
							showCreditBreakdown={!isAskgvt()}
						/>
					)}
				</Show>
			)}
		/>
	);
};
